import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';


import UserCreate from '../users/UserCreate';
import { closeModal } from '../../actions/modalAction';

const actions = { closeModal };

class RegisterModal extends Component {
  render() {
    return (
      <Modal size="small" 
      open={true} 
      onClose={this.props.closeModal}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      basic
      > 
        <Modal.Content >
          <UserCreate/>
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(RegisterModal);
